import { render, staticRenderFns } from "./NewsletterUnsubscribe.vue?vue&type=template&id=57f0113a&scoped=true&"
import script from "./NewsletterUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./NewsletterUnsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterUnsubscribe.vue?vue&type=style&index=0&id=57f0113a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0113a",
  null
  
)

export default component.exports